import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Input from 'core/elements/input/Input'
import Button from 'core/elements/button'
import Theme from 'core/themes/model'

const useStyles = makeStyles((theme: Theme) => ({
  signinButton: {
    marginTop: 16,
    width: '100%',
  },
}))

interface SSOLoginFormProps {
  domain: string
  loading: boolean
  updateValue: (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => void
  redirectToSsoLogin: () => void
}

const SSOLoginForm: React.FC<SSOLoginFormProps> = ({
  domain,
  loading,
  updateValue,
  redirectToSsoLogin,
}) => {
  const classes = useStyles({})

  return (
    <>
      <Input
        variant="dark"
        id="domain"
        label="Domain"
        type="text"
        value={domain}
        onChange={updateValue('domain')}
      />
      <Button
        id="login-submit"
        type="button"
        loading={loading}
        className={classes.signinButton}
        onClick={redirectToSsoLogin}
      >
        Sign In With SSO
      </Button>
    </>
  )
}

export default SSOLoginForm
